import Vue from 'vue';
import unique from 'unique-selector';

// TODO Rename to selectionManager?
export default Vue.extend({

    props: {
        activeMode: String,
    },

    data()
    {
        return {
            enabled: true,
            alternativeSelection: {
                mouseCoords: {
                    left: null,
                    right: null,
                },
                editors: [],
            },
            currentHover: null,
            currentSelection: null,
        };
    },

    methods: {

        setEnabled(enabled)
        {
            this.enabled = !!enabled;
        },

        setUserSelection(editor, mouseCoords)
        {
            // Abort due to current editor requests to wait (probarly dirty).
            if(this.currentSelection?.tryToDeselect && !this.currentSelection.tryToDeselect())
                return;

            // Get alternative selection.
            this.manageAlternativeSelection(editor, mouseCoords);

            //
            this.setSelection(this.alternativeSelection.editors.length == 1 ? editor : null);
        },

        manageAlternativeSelection(editor, mouseCoords)
        {
            let result = [];

            // Get intended editor offset.
            //let editorDimensions = editor.getElementDimensions();

            // Loop
            for(let alternativeEditor of window.pageComponent.getEditors())
            {
                // Add due to same or has panel component and is nearby?
                if(alternativeEditor == editor || (alternativeEditor.panelComponent && alternativeEditor.mouseIsNearby(mouseCoords, editor)))
                    result.push(alternativeEditor);
            }

            // Set
            this.alternativeSelection = {
                mouseCoords,
                editors: result
            };
        },

        setSelection(editor)
        {
            // Error due to not enabled?
            if(!this.enabled)
                throw 'Cannot set selection due to not enabled!';

            // Unselect due to was already selected?
            if(this.currentSelection == editor)
                editor = null;

            // Clear alternatives?
            if(editor)
                this.clearAlternatives();

            // Set
            this.currentSelection = editor;
        },

        clearAlternatives()
        {
            this.alternativeSelection.editors.splice(0, this.alternativeSelection.editors.length);

            this.currentHover = null;
        },

        setHover(editor)
        {
            // Set
            this.currentHover = editor;
        },

        restoreSelectionAfterNewHtml(refresherFn)
        {
            // Abort due to nothing to restore?
            if(!this.currentSelection || this.currentSelection.element.closest('body').length == 0)
                return refresherFn(() => {});

            // Get unique selector of element.
            let editorElementSelector = unique(this.currentSelection.element.get(0));

            // Refresh HTML.
            refresherFn(() =>
            {
                // Restore
                this.currentSelection = $(editorElementSelector).data('vueInstance');
            });
        },

    },

    computed: {

        hasAlternativeEditors()
        {
            return this.alternativeSelection.editors.length > 1;
        },

    },

    watch: {

        'activeMode'()
        {
            // Clear selection.
            this.currentSelection = null;
        },

    },

});